import { DataTableColumn } from '../../data-table.config';

export type DataTableColumnTextFilter = 'text' | 'select' | 'autocomplete' | 'date' | 'multiselect' | 'number-range';

export interface DataTableBadge {
  label: string;
  cssClass?: string;
  caption?: string;
}

export class DataTableColumnText implements DataTableColumn {
  attribute: string;
  header: string;
  value?: (item: any) => any;
  note?: (item: any) => string | null | undefined;
  badges?: (item: any) => DataTableBadge[];
  badgesLayout?: 'inline' | 'vertical';
  badgesSeparator?: string;
  filter?: DataTableColumnTextFilter;
  width?: string;
  style?: any;
  filterOptionsSource?: string;
  defaultFilterValue?: any;
  options?: Array<any>;
  sortable?: boolean;
  filterMinAttribute?: string;
  filterMaxAttribute?: string;
  dependsOn?: {
    column: string;
    fetchOptionsMethod?: string;
  };

  constructor(config: {
    attribute: string;
    header: string;
    value?: (item: any) => any;
    note?: (item: any) => string | null | undefined;
    badges?: (item: any) => DataTableBadge[];
    badgesLayout?: 'inline' | 'vertical';
    badgesSeparator?: string;
    filter?: DataTableColumnTextFilter;
    width?: string;
    style?: any;
    filterOptionsSource?: string;
    defaultFilterValue?: any;
    options?: Array<any>;
    sortable?: boolean;
    filterMinAttribute?: string;
    filterMaxAttribute?: string;
    dependsOn?: {
      column: string;
      fetchOptionsMethod?: string;
    };
  }) {
    this.attribute = config.attribute;
    this.header = config.header;
    this.value = config.value;
    this.note = config.note;
    this.badges = config.badges;
    this.badgesLayout = config.badgesLayout;
    this.badgesSeparator = config.badgesSeparator;
    this.filter = config.filter;
    this.width = config.width;
    this.style = config.style;
    this.filterOptionsSource = config.filterOptionsSource;
    this.defaultFilterValue = config.defaultFilterValue;
    this.options = config.options;
    this.sortable = config.sortable;
    this.filterMinAttribute = config.filterMinAttribute;
    this.filterMaxAttribute = config.filterMaxAttribute;
    this.dependsOn = config.dependsOn;
  }
}
